import { Component, inject } from "@angular/core";
import { Marketplace, Targeting } from "@front/m19-api-client";
import { IButtonComponent, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { KeywordListManagerComponent } from "@m19-board/shared/keyword-list-manager/keyword-list-manager.component";
import { SpinnerComponent } from "@m19-board/spinner/spinner.component";
import { ICON_CLOSE } from "@m19-board/utils/iconsLabels";

export interface StrategyKeywordModalData {
  marketplace: Marketplace;
  keywords: Targeting[];
  isReadOnly: boolean;
  loading?: boolean;
}

export enum StrategyKeywordModalResult {
  ADDED_KEYWORDS,
  DELETED_KEYWORDS,
}

export interface StrategyKeywordModalOutput {
  result: StrategyKeywordModalResult;
  keywords: Targeting[];
}

@Component({
  selector: "app-strategy-keyword-modal",
  template: ` <div class="flex h-[60vh] w-[60rem] flex-col gap-4 p-3">
      <app-spinner
        [display]="!!modalData.loading"
        class="absolute top-48 flex w-full items-center justify-center"
      ></app-spinner>
      <keyword-list-manager [initTargetings]="modalData.keywords" (targetingsChanged)="onKeywordsChanged($event)" />
    </div>
    <div class="flex justify-end gap-2 p-3" *transloco="let t">
      <IButton label="{{ t('common.close') }}" color="white" (onClick)="modalRef.close()" />
    </div>`,
  imports: [SpinnerComponent, TranslocoDirective, IButtonComponent, KeywordListManagerComponent],
  standalone: true,
})
export class StrategyKeywordModalComponent {
  protected readonly modalData = inject(MODAL_DATA) as StrategyKeywordModalData;
  readonly modalRef = inject(ModalRef);

  readonly ICON_CLOSE = ICON_CLOSE;
  readonly StrategyKeywordModalResult = StrategyKeywordModalResult;

  onKeywordsChanged(keywords: Targeting[]) {
    const toAdd = keywords.filter((k) => !this.modalData.keywords.includes(k));
    const toDelete = this.modalData.keywords.filter((k) => !keywords.includes(k));
    if (toAdd.length > 0) {
      this.modalRef.close({ result: StrategyKeywordModalResult.ADDED_KEYWORDS, keywords: toAdd });
    }
    if (toDelete.length > 0) {
      this.modalRef.close({ result: StrategyKeywordModalResult.DELETED_KEYWORDS, keywords: toDelete });
    }
  }
}
